import type { Provider } from "./types"

export const formatProviderInitials = (name: string): string => {
  const [firstName, lastName] = name.trim().split(" ")
  const firstInitial = firstName?.charAt(0).toUpperCase() ?? ""
  const lastInitial = lastName?.charAt(0).toUpperCase() ?? ""
  return `${firstInitial}${lastInitial}`
}

// TODO: Determine better way to format titles/honorifics.
export const formatProviderName = (provider: Pick<Provider, "name" | "title">): string =>
  provider.title ? `Dr. ${provider.name}, ${provider.title}` : `Dr. ${provider.name}`

export const formatAppointmentDate = (date: Date): string =>
  date.toLocaleDateString("en-US", { month: "short", day: "numeric" })

export const formatAppointmentDateLong = (date: Date): string =>
  date.toLocaleDateString("en-US", { weekday: "short", month: "short", day: "numeric" })

export const formatAppointmentTime = (date: Date): string =>
  date.toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit" })

// Past appointment dates are date-only strings; pin to UTC so they don't shift a day in local time.
export const formatPastAppointmentDate = (date: string): string =>
  new Date(date).toLocaleDateString("en-US", {
    weekday: "short",
    month: "short",
    day: "numeric",
    timeZone: "UTC"
  })

export const getDaysUntil = (date: Date): number =>
  Math.ceil((date.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24))
